import { CircularProgress } from '@mui/material';
import { DataGrid, GridColDef, GridSelectionModel } from '@mui/x-data-grid';
import { License, Module } from '../../api/api-generated';
import { useFindAllModulesQuery } from '../../api/api-hooks';
import { Item } from '../../utils/sharedTypes';

interface Props {
  setSelectedModules: React.Dispatch<React.SetStateAction<Item[]>>;
  license?: License;
}

const ModulesTable = ({ setSelectedModules, license }: Props) => {
  const { data: modules } = useFindAllModulesQuery({});
  if (modules === undefined) return <CircularProgress></CircularProgress>;
  // Define data for display in DataGrid
  const columns: GridColDef[] = [
    { field: 'moduleName', headerName: 'Module Name', width: 200 },
  ];
  const rows = modules
    .filter((item: Module) =>
      license
        ? item.licenses.some(
            (possibleMatchingLicense) =>
              possibleMatchingLicense.companyId === license.companyId &&
              possibleMatchingLicense.softwareId === license.softwareId &&
              possibleMatchingLicense.hardwareId === license.hardwareId
          )
        : true
    )
    .map((item: Module) => ({
      ...item,
    }));
  const handleTableSelection = (model: GridSelectionModel) => {
    setSelectedModules(
      modules.filter((category) => model.includes(category.id))
    );
  };
  return (
    <div style={{ paddingBottom: '1rem', width: '100%' }}>
      <DataGrid
        rows={rows}
        columns={columns}
        pageSize={8}
        checkboxSelection
        disableSelectionOnClick
        autoHeight
        disableColumnMenu={true}
        onSelectionModelChange={handleTableSelection}
      />
    </div>
  );
};

export default ModulesTable;
